export enum BrowserType {
  Default = 'default',
  Chromium = 'chromium',
  CustomChromiumStable = 'customChromiumStable',
  PuppetBridge = 'puppetBridge',
  CustomBrave = 'customBrave',
  BrowserLess = 'browserLess',
}

export const isBrowserType = (browserType: string): browserType is BrowserType => {
  return Object.values(BrowserType).includes(browserType as BrowserType);
};
